<script lang="ts">
	import { ClientVelatlasLoggerApi } from '$lib/api/velatlas/velatlas.loggerApi.client';
	import { ANALYTICS_EVENT_NAMES } from '$lib/statics';
	import { onMount } from 'svelte';

	const { videoId, playLabel }: { videoId: string; playLabel?: string } = $props();

	const analyticsApi = new ClientVelatlasLoggerApi();

	let player = $state<HTMLElement | null>(null);

	onMount(() => {
		const onPlay = () => {
			analyticsApi.sendAnalytics({
				event: ANALYTICS_EVENT_NAMES.videoPlay,
				payload: { type: 'youtube', videoId, title: playLabel }
			});
		};

		player?.addEventListener('liteYoutubeIframeLoaded', onPlay, { once: true });

		import('@justinribeiro/lite-youtube');

		return () => player?.removeEventListener('liteYoutubeIframeLoaded', onPlay);
	});
</script>

<lite-youtube bind:this={player} videoid={videoId} videotitle={playLabel} params="rel=0&mute=1&cc_load_policy=1" nocookie>
	<a href="https://www.youtube.com/watch?v={videoId}" class="sr-only" target="_blank" rel="noopener">
		{playLabel} on YouTube
	</a>
</lite-youtube>

<style>
	lite-youtube {
		display: block;
		width: 100%;
		height: 100%;
		border-radius: inherit;
		overflow: hidden;
		background-color: #000;
	}
</style>
